<script lang="ts">
  export let count: number
</script>

<div class="count">{JSON.stringify(count)}</div>

<style lang="scss">
  .count {
    background-color: #E0E8F6;
    height: 24px;
    border-radius: 8px;
    padding: 2px 8px;
    color: #3736D7;
    line-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
  }
</style>